import React from 'react';
import monochromeWhiteIcon from '../../assets/brand/VocabAI_icon_monochrome_white.png';
import { Phone, MessageSquare, Smartphone, Mail } from 'lucide-react'; // Removed MessageCircle
import WhatsAppIcon from '../../assets/icons/whatsapp.svg'; // Import the new WhatsApp icon

export const HeroGraphic = () => {
  return (
    <div className="relative w-full max-w-[480px] aspect-square mx-auto flex items-center justify-center my-0 overflow-hidden">

      {/* Background Rotating Orbit Rings */}
      <div className="absolute w-[82%] h-[82%] rounded-full border border-purple-100 animate-spin-slow-30s pointer-events-none" />
      <div className="absolute w-[62%] h-[62%] rounded-full border border-pink-100/60 animate-spin-slow-20s-reverse pointer-events-none" />

      {/* Central Solid Gradient Circle Hub with Hover Scale */}
      <div className="relative z-10 w-44 h-44 md:w-52 md:h-52 rounded-full bg-gradient-to-tr from-[#5E17EB] via-[#EC4899] to-[#FF6B00] p-8 shadow-2xl shadow-purple-500/35 flex items-center justify-center transition-transform duration-500 hover:scale-105 cursor-pointer">
        <img
          src={monochromeWhiteIcon}
          alt="Vocab AI Icon"
          className="w-full h-full object-contain filter drop-shadow-md transition-transform duration-500 hover:rotate-12"
        />
      </div>

      {/* 5 Orbiting Channel Nodes with Interactive Hover Effects */}

      {/* 1. Telephone */}
      <div className="absolute top-[1%] left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 z-25 transition-transform duration-300 hover:scale-110 cursor-pointer">
        <div className="w-14 h-14 rounded-full bg-purple-50/80 border border-purple-100 flex items-center justify-center shadow-sm">
          <div className="w-10 h-10 rounded-full bg-[#7C3AED] text-white flex items-center justify-center shadow-md shadow-purple-500/30 transition-transform hover:rotate-12">
            <Phone className="w-4 h-4 fill-current"/>
          </div>
        </div>
        <span className="text-[11px] font-bold text-slate-800">Telephone</span>
      </div>

      {/* 2. Web Chat */}
      <div className="absolute top-[20%] right-[1%] flex flex-col items-center gap-1 z-25 transition-transform duration-300 hover:scale-110 cursor-pointer">
        <div className="w-14 h-14 rounded-full bg-pink-50/80 border border-pink-100 flex items-center justify-center shadow-sm">
          <div className="w-10 h-10 rounded-full bg-[#EC4899] text-white flex items-center justify-center shadow-md shadow-pink-500/30 transition-transform hover:-rotate-12">
            <MessageSquare className="w-4 h-4 fill-current"/>
          </div>
        </div>
        <span className="text-[11px] font-bold text-slate-800">Web Chat</span>
      </div>

      {/* 3. Mobile App */}
      <div className="absolute bottom-[8%] right-[8%] flex flex-col items-center gap-1 z-25 transition-transform duration-300 hover:scale-110 cursor-pointer">
        <div className="w-14 h-14 rounded-full bg-purple-50/80 border border-purple-100 flex items-center justify-center shadow-sm">
          <div className="w-10 h-10 rounded-full bg-[#8B5CF6] text-white flex items-center justify-center shadow-md shadow-purple-500/30 transition-transform hover:rotate-12">
            <Smartphone className="w-4 h-4"/>
          </div>
        </div>
        <span className="text-[11px] font-bold text-slate-800 text-center leading-tight">Mobile<br/>App</span>
      </div>

      {/* 4. SMS */}
      <div className="absolute bottom-[8%] left-[14%] flex flex-col items-center gap-1 z-25 transition-transform duration-300 hover:scale-110 cursor-pointer">
        <div className="w-14 h-14 rounded-full bg-rose-50/80 border border-rose-100 flex items-center justify-center shadow-sm">
          <div className="w-10 h-10 rounded-full bg-[#F43F5E] text-white flex items-center justify-center shadow-md shadow-rose-500/30 transition-transform hover:-rotate-12">
            <Mail className="w-4 h-4"/>
          </div>
        </div>
        <span className="text-[11px] font-bold text-slate-800">SMS</span>
      </div>

      {/* 5. WhatsApp */}
      <div className="absolute top-[20%] left-[1%] flex flex-col items-center gap-1 z-25 transition-transform duration-300 hover:scale-110 cursor-pointer">
        <div className="w-14 h-14 rounded-full bg-emerald-50/80 border border-emerald-100 flex items-center justify-center shadow-sm">
          <div className="w-10 h-10 rounded-full bg-[#22C55E] text-white flex items-center justify-center shadow-md shadow-emerald-500/30 transition-transform hover:rotate-12">
            <img src={WhatsAppIcon} alt="WhatsApp" className="w-5 h-5" /> {/* Changed to w-5 h-5 */}
          </div>
        </div>
        <span className="text-[11px] font-bold text-slate-800">WhatsApp</span>
      </div>

    </div>
  );
};
